import * as R from "ramda";
import { call, reducer, reset } from "../../helpers/api/meta";
import { getCourseDetail } from "../../helpers/api/api";

export const GET_COURSE_DETAIL = "GET_COURSE_DETAIL";

export const callGetCourseDetail = (inputs) => {
  const meta = {
    endpoint: (params) => getCourseDetail(params),
    inputs,
    action: GET_COURSE_DETAIL,
    messages: {
      id: "getCourseDetail",
      failure: "Could not get course detail",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  detail: {},
  enrolment: {},
};

const saveCourseDetail = (state, action) => {
  if (action && action.course) {
    const course = { ...action.course };
    const enrolment = {
      ...action,
      course: null,
    };
    const updatedState = R.assoc("detail", course, state);
    return R.assoc("enrolment", enrolment, updatedState);
  } else {
    return R.assoc("detail", action, state);
  }
};

export const callResetCourseDetail = () => (dispatch) => {
  dispatch(reset(GET_COURSE_DETAIL));
};

const messages = {
  loadFailed: "Could not load courses.",
};

export default reducer(
  initialState,
  GET_COURSE_DETAIL,
  saveCourseDetail,
  messages.loadFailed
);
